import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleCorrectBalanceUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#999" />
      <rect width={24} height={28} x={16} y={14} fill="#fff" rx={1.5} />
      <path
        fill="#999"
        d="M29 28.4c.28 0 .5.22.5.5v.7a.5.5 0 01-.5.5h-8a.5.5 0 01-.5-.5v-.7c0-.28.22-.5.5-.5zm6-4.2c.28 0 .5.22.5.5v.7a.5.5 0 01-.5.5H21a.5.5 0 01-.5-.5v-.7c0-.28.22-.5.5-.5zm0-4.2c.28 0 .5.22.5.5v.7a.5.5 0 01-.5.5H21a.5.5 0 01-.5-.5v-.7c0-.28.22-.5.5-.5z"
      />
      <circle cx={38} cy={36} r={9} fill="#CCC" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M42.86 33.26c.2.2.2.51 0 .7l-5.5 5.5a.5.5 0 01-.7 0l-3.5-3.5a.5.5 0 010-.7l.7-.7c.2-.2.51-.2.7 0l2.45 2.43 4.44-4.44c.2-.2.5-.2.7 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

SvgPicCircleCorrectBalanceUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleCorrectBalanceUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleCorrectBalanceUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
